import { getMarkerStyles } from 'app/core/markers/models';
import { compilePath } from 'app/core/rendering/compiler';
import { strokeMarkerRenderer } from './painters';
export const renderPathMarker = (marker, opts, ctx) => {
    const item = marker;
    const painter = compilePath(item.data);
    ctx.save();
    ctx.translate(item.x, item.y);
    strokeMarkerRenderer(ctx, getMarkerStyles(marker), painter, opts);
    ctx.restore();
};
